import React from "react";

export default function MapEmbed({ address, name }) {
  if (!address) return null;
  const q = encodeURIComponent(address);
  // OpenStreetMap embed using a search via nominatim bbox isn't ideal; use tile embed centered via q param
  const osm = `https://www.openstreetmap.org/export/embed.html?bbox=-180%2C-80%2C180%2C80&layer=mapnik&marker=0,0`;
  // Simpler reliable approach: use Google Maps search (no API key required for iframe embed)
  const gmaps = `https://maps.google.com/maps?q=${q}&output=embed`;
  const directions = `https://www.google.com/maps/dir/?api=1&destination=${q}`;
  return (
    <div className="border border-black/10 overflow-hidden">
      <iframe
        data-testid="map-embed"
        title={name || "Event location"}
        src={gmaps}
        className="w-full h-72 block"
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
      <a
        href={directions}
        target="_blank"
        rel="noreferrer"
        data-testid="directions-link"
        className="block text-center py-3 text-xs tracking-[0.25em] uppercase bg-neutral-900 text-white hover:bg-neutral-700 transition-colors"
      >
        Get directions →
      </a>
    </div>
  );
}
